module.exports = __webpack_public_path__ + "img/hurling.bb60c19b.svg";